import React from 'react';
import PropTypes from 'prop-types';
import {
  Route,
  Redirect,
} from 'react-router-dom';

import { isLoggedIn } from '../api/Auth';
import { cleanLoginParams } from './App';

import withDragAndDropContext from './withDragAndDropContext';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      (isLoggedIn() || (!window.sp.mini && props.location.pathname === '/')) ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            search: props.location.search,
            state: {
              from: `${props.location.pathname}${cleanLoginParams(props.location.search)}`,
            },
          }}
        />
      )
    )}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.object,
};

PrivateRoute.defaultProps = {
  location: null,
};

export default withDragAndDropContext(PrivateRoute);
